// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"f951e6a3","585":"44a4ec1f"}[chunkId] + ".chunk.js";
};